<script lang="ts">
    
</script>

<div class="map-busy-alert">
    <div class="map-busy-alert-content">
        <slot />
    </div>
</div>
